import { ComputeRetentionMetricsResponse } from '@fullstory/proto/fs/services/alexa';
import {
  GetAllRetentionMetricsResponse,
  RetentionMetricDetail,
} from '@fullstory/proto/fs/services/dx-objects';
import { int64, timestamp, Timestamp } from '@fullstory/proto/google/protobuf';
import { RetentionResultWithId } from '@fullstory/redux';
import { MockGetAllResponseParams } from '@fullstory/ui-mocks/utils/types';
import { mockRetentionDetail } from './utils';

export const GET_ALL_RETENTION_METRICS_RESPONSE: GetAllRetentionMetricsResponse = {
  retentionMetrics: [],
};

export const mockGetAllRetentionMetricsResponse = ({
  numberOfObjects = 10,
}: MockGetAllResponseParams): GetAllRetentionMetricsResponse => {
  const testRetentions: RetentionMetricDetail[] = [];
  if (numberOfObjects > 0) {
    //  Including objects with long names to test ellipsizing
    testRetentions.push(
      mockRetentionDetail({
        id: 'testRetention',
        name: 'test retention with a very very very very very very very very very long name',
      }),
    );
  }
  for (let i = 0; i < numberOfObjects - 1; i++) {
    const retentionId = `testRetention${i}`;
    testRetentions.push(
      mockRetentionDetail({
        id: retentionId,
        name: `Test Retention ${i}`,
        metadata: i % 2 === 0 ? { lastUpdated: null } : undefined,
        lastViewed: i % 2 === 0 ? null : Timestamp.now(),
        starred: i % 3 === 0 ? true : false,
      }),
    );
  }

  return {
    retentionMetrics: testRetentions,
  };
};

export const defaultResponse: RetentionResultWithId = {
  retentions: [
    {
      cohort: [
        {
          entryStart: '2022-08-20T07:00:00Z' as timestamp,
          entryEnd: '2022-08-21T07:00:00Z' as timestamp,
          count: int64.fromNumber(4256),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(4246),
                int64.fromNumber(885),
                int64.fromNumber(990),
                int64.fromNumber(945),
                int64.fromNumber(873),
                int64.fromNumber(822),
                int64.fromNumber(568),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(4246),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(885),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(990),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(945),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(873),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(822),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(568),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-21T07:00:00Z' as timestamp,
          entryEnd: '2022-08-22T07:00:00Z' as timestamp,
          count: int64.fromNumber(8263),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(8248),
                int64.fromNumber(1212),
                int64.fromNumber(967),
                int64.fromNumber(846),
                int64.fromNumber(793),
                int64.fromNumber(424),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(8248),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1212),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(967),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(846),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(793),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(424),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-22T07:00:00Z' as timestamp,
          entryEnd: '2022-08-23T07:00:00Z' as timestamp,
          count: int64.fromNumber(13436),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(13400),
                int64.fromNumber(3997),
                int64.fromNumber(3419),
                int64.fromNumber(3153),
                int64.fromNumber(2260),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(13400),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3997),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3419),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(3153),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(2260),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-23T07:00:00Z' as timestamp,
          entryEnd: '2022-08-24T07:00:00Z' as timestamp,
          count: int64.fromNumber(10325),
          returnEventCounts: [
            {
              counts: [
                int64.fromNumber(10288),
                int64.fromNumber(1916),
                int64.fromNumber(1432),
                int64.fromNumber(890),
              ],
              eventCounts: [
                {
                  count: int64.fromNumber(10288),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1916),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1432),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(890),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-24T07:00:00Z' as timestamp,
          entryEnd: '2022-08-25T07:00:00Z' as timestamp,
          count: int64.fromNumber(9359),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(8574), int64.fromNumber(1353), int64.fromNumber(674)],
              eventCounts: [
                {
                  count: int64.fromNumber(8574),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(1353),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(674),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-25T07:00:00Z' as timestamp,
          entryEnd: '2022-08-26T07:00:00Z' as timestamp,
          count: int64.fromNumber(8194),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(8180), int64.fromNumber(797)],
              eventCounts: [
                {
                  count: int64.fromNumber(8180),
                  isPartialPeriod: false,
                },
                {
                  count: int64.fromNumber(797),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
        {
          entryStart: '2022-08-26T07:00:00Z' as timestamp,
          entryEnd: '2022-08-27T07:00:00Z' as timestamp,
          count: int64.fromNumber(4115),
          returnEventCounts: [
            {
              counts: [int64.fromNumber(4070)],
              eventCounts: [
                {
                  count: int64.fromNumber(4070),
                  isPartialPeriod: true,
                },
              ],
            },
          ],
          isPartialPeriod: false,
        },
      ],
      groups: [],
      id: '67f30a34-4796-458b-92be-86e51c595da4',
    },
  ],
  numGroups: int64.fromNumber(0),
};

export const mockRetentionComputationResult: ComputeRetentionMetricsResponse = {
  retention: {
    ...defaultResponse,
  },
  computedAt: '2023-01-06T01:10:34.692526170Z' as timestamp,
  backgroundRefId: '',
  sampleResults: null,
};
